import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Loader from 'components/Loader';
import { useGetRewardHistory } from 'hooks/useGetRewardHistory';

import './reward-history.scss';

function normalizeHistoryPayload(rewardHistory) {
  if (rewardHistory == null) {
    return {
      pointsHistory: [],
      expiringDetail: '',
    };
  }
  if (Array.isArray(rewardHistory)) {
    return {
      pointsHistory: rewardHistory,
      expiringDetail: '',
    };
  }
  return {
    pointsHistory: rewardHistory.PointsHistory ?? [],
    expiringDetail:
      rewardHistory.PointsExpiringSoonText ??
      rewardHistory.ExpiringPointsString ??
      rewardHistory.expiring_detail ??
      '',
  };
}

const RewardHistory = () => {
  const location = useLocation();
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { lmRewardId, isPointBased, lmRewardData } = location.state ?? {};

  const { rewardHistory, isLoading, error } = useGetRewardHistory(lmRewardId);

  const { pointsHistory, expiringDetail } = useMemo(
    () => normalizeHistoryPayload(rewardHistory),
    [rewardHistory]
  );

  if (!lmRewardId) {
    return (
      <div className="reward-history-page">
        <p className="reward-history-missing">Open history from a reward to see points activity.</p>
      </div>
    );
  }

  return (
    <div className="reward-history-page">
      {isLoading ? <Loader /> : null}
      {!isLoading && error ? (
        <div className="reward-history-error">Something went wrong. Please try again.</div>
      ) : null}

      {!isLoading && !error ? (
        <>
          <div className="reward-history-expiring">
            <div className="reward-history-expiring-copy">
              {lmRewardData?.PointsExpireString ? (
                <div className="reward-history-expiring-points">
                  {lmRewardData.PointsExpireString}
                </div>
              ) : null}
              <div className="reward-history-expiring-title">
                <svg
                  className="reward-history-expiring-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
                <span>{lmRewardData?.NoOfPointsExpireString}</span>
              </div>
            </div>
            {isUserLoggedIn &&
              lmRewardData?.is_points_based &&
              lmRewardData?.IsItQualifiedforReward ? <Link
              className="reward-history-redeem"
              to="/rewardsdetails"
              state={{
                lmRewardId,
                Redeem: true,
                isPointBased,
                lmRewardData,
              }}
            >
              Redeem
            </Link> : null}
          </div>

          <div className="reward-history-list">
            {pointsHistory.length === 0 ? (
              <p className="reward-history-empty">No history yet.</p>
            ) : (
              pointsHistory.map((group) => (
                <section key={group.date}>
                  <h2 className="reward-history-date">{group.date}</h2>
                  <ul className="reward-history-items">
                    {(group.PointsInfo ?? []).map((row, idx) => (
                      <li key={`${group.date}-${idx}`}>
                        <div className="reward-history-points">
                          {row.PointsString}
                        </div>
                        <div className="reward-history-meta">{row.PointsTypeText ?? ''}</div>
                      </li>
                    ))}
                  </ul>
                </section>
              ))
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default RewardHistory;
